var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c("router-link", { attrs: { to: _vm.paymentRouterLinkAction } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6" }, [
            _vm.$userIsAdmin
              ? _c("h3", [
                  _vm._v(
                    _vm._s(_vm.booking.name) +
                      " – " +
                      _vm._s(_vm.bookingPaymentType)
                  ),
                ])
              : _c("h3", [
                  _vm._v(
                    "#" +
                      _vm._s(_vm._f("padded")(_vm.payment.id, "0", 5)) +
                      " – " +
                      _vm._s(_vm.bookingOpportunityName) +
                      " – " +
                      _vm._s(_vm.bookingPaymentType)
                  ),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-4 col-sm-2 col-md-2 col-lg-1" }, [
            _c("p", [
              _vm.bookingPaymentIsOverdue
                ? _c("span", { staticClass: "label label-danger" }, [
                    _c("i", {
                      staticClass: "fa fa-exclamation-triangle fa-fw",
                    }),
                    _vm._v(" Overdue"),
                  ])
                : _vm.bookingPaymentIsUnpaid
                ? _c("span", { staticClass: "label label-info" }, [
                    _vm._v("Unpaid"),
                  ])
                : _vm.bookingPaymentIsSent
                ? _c("span", { staticClass: "label label-info" }, [
                    _vm._v("Sent"),
                  ])
                : _vm.bookingPaymentIsOnHold
                ? _c("span", { staticClass: "label label-info" }, [
                    _vm._v("On Hold"),
                  ])
                : _vm.bookingPaymentIsPaid
                ? _c("span", { staticClass: "label label-success" }, [
                    _c("i", { staticClass: "fa fa-check fa-fw" }),
                    _vm._v(" Paid "),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.bookingPaymentIsPaid
              ? _c("p", [
                  _c("span", { staticClass: "label label-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("humanize")(_vm.payment.transaction.method)
                      ) + " "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-2" }, [
            _vm.bookingPaymentIsPaid
              ? _c("p", [
                  _c("i", { staticClass: "fa fa-calendar" }),
                  _vm._v(
                    " Paid On: " +
                      _vm._s(
                        _vm._f("date")(
                          _vm.payment.paid_date,
                          _vm.$user.date_format_preference
                        )
                      )
                  ),
                ])
              : _vm.bookingPaymentIsSent
              ? _c("p", [
                  _c("i", { staticClass: "fa fa-calendar" }),
                  _vm._v(
                    " Sent On: " +
                      _vm._s(
                        _vm._f("date")(
                          _vm.payment.sent_date,
                          _vm.$user.date_format_preference
                        )
                      )
                  ),
                ])
              : _c("p", [
                  _c("i", { staticClass: "fa fa-calendar" }),
                  _vm._v(
                    " Due By: " +
                      _vm._s(
                        _vm._f("date")(
                          _vm.payment.due_date,
                          _vm.$user.date_format_preference
                        )
                      )
                  ),
                ]),
          ]),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c(
                "div",
                { staticClass: "col-xs-4 col-sm-3 col-md-3 col-lg-2" },
                [_c("p", [_vm._v("Booking ID: " + _vm._s(_vm.booking.id))])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-sm-3 col-md-3 col-lg-1" }, [
            _c("span", { staticClass: "price" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.payment.total_inclusive,
                    _vm.booking.currency
                  )
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.canEditPaymentDueDate
        ? _c(
            "a",
            {
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": _vm.dueDateModalId,
              },
            },
            [_vm._v("Edit Due Date")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin
        ? _c("booking-edit-payment-due-date-modal", {
            attrs: {
              "payment-id": _vm.payment.id,
              "payment-due-date": _vm.payment.due_date,
              location: "payments",
              "update-payment": _vm.updatePayment,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }